import { FormattingContext, LANGUAGE_TO_LOCALE, SYSTEM_FALLBACK, SupportedLanguage, TenantCultureDefaults } from './formatting-context';

/**
 * Resolves a fully-qualified FormattingContext from layered inputs following
 * the precedence chain: user override → tenant defaults → system fallback.
 *
 * @param language - The active user/app language (e.g. 'de')
 * @param tenantDefaults - Optional partial culture profile from tenant config
 * @param userOverride - Optional partial context from user preferences
 */
export function resolveFormattingContext(
  language: string,
  tenantDefaults?: TenantCultureDefaults,
  userOverride?: Partial<FormattingContext>
): FormattingContext {
  const baseLocale = resolveLocaleFromLanguage(language);

  return {
    locale: userOverride?.locale ?? tenantDefaults?.locale ?? baseLocale,
    currency: userOverride?.currency ?? tenantDefaults?.currency ?? SYSTEM_FALLBACK.currency,
    timeZone: userOverride?.timeZone ?? tenantDefaults?.timeZone ?? SYSTEM_FALLBACK.timeZone,
  };
}

/**
 * Resolves a BCP-47 locale string from a language code.
 * Falls back to the system default if the language is not supported.
 */
export function resolveLocaleFromLanguage(language: string): string {
  return LANGUAGE_TO_LOCALE[language as SupportedLanguage] ?? SYSTEM_FALLBACK.locale;
}
